import React from 'react';
import Header from './Header';
import Home from './Home';
import CategoriesSection from './CategoriesSection';
import FeaturedProducts from './FeaturedProducts';
import Informations from './Informations';
import HomePageGallery from './HomePageGallery';
import Footer from './Footer';

function MainPage() {
    return (
        <>
            <Header />
            <Home />
            <CategoriesSection />
            <FeaturedProducts />
            <Informations />
            <HomePageGallery />
            <Footer />
        </>
    );
}

export default MainPage;
